import {
	ISurveyTrackingData,
	ISurveyRoundResponse,
} from 'modules/admin-panel/pages/settings/models';

export const mapSurveyDates = (
	list: ISurveyTrackingData[],
	data: ISurveyRoundResponse,
): ISurveyTrackingData[] => {
	return list.map((survey) => {
		const { id, startDate, sendingTime, endDate, status } = data;
		return {
			...survey,
			surveyRounds: survey.surveyRounds.map((round) => {
				if (round.id === id) {
					return {
						...round,
						startDate,
						endDate,
						startTime: sendingTime,
						status,
					};
				}
				return round;
			}),
		};
	});
};
